import * as IconSelector from '../icons';

// Constantes exportadas
export const USE_FORM_SOLICITUD = 'Solicitud';
export const USE_FORM_ACTA = 'Acta';
export const USE_FORM_RESOLUTION = 'Resolucion';

// Definición del enum
export const usesForm = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: USE_FORM_SOLICITUD,
        label: 'Solicitud',
        description: 'Formulario de solicitud',
        icon: IconSelector.SolicitudesIcon,
        color: 'Blue'
    },
    {
        value: USE_FORM_ACTA,
        label: 'Acta',
        description: 'Formulario de acta',
        icon: IconSelector.ActasIcon,
        color: 'Orange'
    },
    {
        value: USE_FORM_RESOLUTION,
        label: 'Resolucion',
        description: 'Resultado inspeccion',
        icon: IconSelector.VerifiedIcon,
        color: 'Green'
    }
];
